export const OPTION_RECOMMENDATIONS = "OPTION_RECOMMENDATIONS";
export const OPTION_RECOMMENDATIONS_LOADER = "OPTION_RECOMMENDATIONS_LOADER";
export const OPTION_RECOMMENDATIONS_ERROR = "OPTION_RECOMMENDATIONS_ERROR";
export const OPTION_RECOMMENDATIONS_HIDE_ERROR = "OPTION_RECOMMENDATIONS_HIDE_ERROR";
export const OPTION_RECOMMENDATIONS_START_LOADER = "OPTION_RECOMMENDATIONS_START_LOADER";
export const OPTION_RECOMMENDATIONS_STOP_LOADER = "OPTION_RECOMMENDATIONS_STOP_LOADER";
